import { useEffect } from "react";

export const Redirect = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, []);

  return null;
};
